import type { IExercise } from '../exercises';

export const FOUR_WAY_EPISODE_02_MATERIALS: IExercise[] = [
  {
    "id": "course-20261008-four-way-02-01",
    "name": "靠墙单臂肩胛前引",
    "bodyPart": "warmup",
    "equipment": "bodyweight",
    "subCategory": "thoracic",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "每侧10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": true,
    "difficulty": "beginner",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-04d859eef528a0cf30c9daf2.mp4",
    "source": "四分化训练 · 第2期",
    "isStretch": false,
    "mediaIssue": "新教学实际为卧推，靠墙肩胛前引教学待补齐",
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-02",
    "name": "高位下拉",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "lat",
    "tips": ["沉肩下拉", "感受背阔收缩"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-cf8350784d7ebecd7b4e433f.mp4",
    "videoUrl": "/media/collections-20261008/videos/b02ba23cb8afa5f0b7e574af.mp4",
    "targetMuscles": ["背阔肌", "肱二头肌"],
    "difficulty": "beginner",
    "source": "四分化训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-03",
    "name": "上斜凳坐姿划船",
    "bodyPart": "back",
    "equipment": "machine",
    "subCategory": "thickness",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 4,
    "reps": "8-12",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["斜方肌中下部", "菱形肌", "背阔肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-738db180f57c36cf1540fe62.mp4",
    "videoUrl": "/media/collections-20261008/videos/ed5a80d220f18c81db79c6f5.mp4",
    "source": "四分化训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-04",
    "name": "坐姿绳索划船",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "row",
    "tips": ["躯干保持稳定", "拉至小腹位置"],
    "sets": 3,
    "reps": "12-15",
    "rpe": 8,
    "restSeconds": 75,
    "isBodyweight": false,
    "demoUrl": "/media/collections-20261008/demos/mobile-4219c5cfd0ab7701325ae121.mp4",
    "videoUrl": "/media/collections-20261008/videos/cad08a8e6e0114c488a119aa.mp4",
    "targetMuscles": ["背阔肌", "菱形肌", "斜方肌中下部", "肱二头肌"],
    "difficulty": "beginner",
    "source": "四分化训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-05",
    "name": "龙门架直臂下压",
    "bodyPart": "back",
    "equipment": "cable",
    "subCategory": "width",
    "tips": ["核心收紧，背部主导发力", "感受背阔肌延展与收缩"],
    "sets": 3,
    "reps": "12",
    "rpe": 7,
    "restSeconds": 60,
    "isBodyweight": false,
    "source": "四分化训练 · 第2期",
    "demoUrl": "/media/collections-20261008/demos/mobile-b880002654c9bbcdda1df6b0.mp4",
    "videoUrl": "/media/collections-20261008/videos/0e25b7a8f2aeaa0859eed4bf.mp4",
    "targetMuscles": ["背阔肌", "大圆肌"],
    "difficulty": "intermediate",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-06",
    "name": "站姿杠铃弯举",
    "bodyPart": "arms",
    "equipment": "barbell",
    "subCategory": "biceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 3,
    "reps": "10-12",
    "rpe": 8,
    "restSeconds": 60,
    "isBodyweight": false,
    "difficulty": "advanced",
    "targetMuscles": ["肱二头肌", "肱肌"],
    "demoUrl": "/media/collections-20261008/demos/reviewed-bc780d0daa87e0645dab58d7.mp4",
    "videoUrl": "/media/collections-20261008/videos/abd7bb925afe79f9a2f0b26f.mp4",
    "source": "四分化训练 · 第2期",
    "isWarmup": false,
    "isStretch": false,
    "demoStatus": "ready",
  },
  {
    "id": "course-20261008-four-way-02-07",
    "name": "跪姿肘屈伸",
    "bodyPart": "arms",
    "equipment": "bodyweight",
    "subCategory": "triceps",
    "tips": ["核心收紧，控制动作节奏", "全程保持肩胛骨稳定"],
    "sets": 2,
    "reps": "10",
    "rpe": 4,
    "restSeconds": 30,
    "isBodyweight": true,
    "isWarmup": false,
    "difficulty": "beginner",
    "targetMuscles": ["肱三头肌", "肘肌"],
    "demoUrl": "/media/collections-20261008/demos/mobile-61ea9491051519656696eb63.mp4",
    "videoUrl": "/media/collections-20261008/videos/9c79ab110fc85dc3e6a228c7.mp4",
    "source": "四分化训练 · 第2期",
    "isStretch": false,
    "demoStatus": "ready",
  },
];
